import { combineReducers } from 'redux';
import global from '../Global/reduser/globalReduser';
import language from '../Global/reduser/languageReduser';
import categories from '../Map/reducers/categoryReducer';
import map from '../Map/reducers/mapReducer';

export default combineReducers({
    global,
    language,
    map,
    categories,
});
